import classNames from "classnames";
import { BankOrderProgress } from "./bankOrderProgress";
import classes from "./styles.module.css";
import { BgBankOrder, BgCart, Status } from "@services/api";

type OrderStatusProps = {
  status: Status;
  carts: BgCart[];
  order: BgBankOrder;
};

export const OrderStatus = ({ status, carts, order }: OrderStatusProps) => {
  if (status === "REJECTED")
    return <div className={classNames(classes.complete, classes.rejected)}>Отказано</div>;
  if (status === "ISSUED")
    return <div className={classNames(classes.complete, classes.issued)}>Выдано</div>;

  return <BankOrderProgress carts={carts} currentCart={order.cart} side={order.side} />;
};
